import _styled from "styled-components";
import React from "react";
import { usePathCreator } from "../Config/useLinkCreator";
import { useHardwareInfo } from "../DeviceData/useHardwareInfo";
import { useRegistersSubscription } from "../DeviceData/useRegistersSubscription";
import { Header } from "../Header/Header";

var Container = _styled.div.withConfig({
  displayName: "InfoPage__Container",
  componentId: "sc-12lduoe-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "InfoPage__Title",
  componentId: "sc-12lduoe-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

var Content = _styled.div.withConfig({
  displayName: "InfoPage__Content",
  componentId: "sc-12lduoe-2"
})(["flex:1;margin-top:50px;font-size:20px;@media screen and (max-width:419px){font-size:18px;}"]);

var Row = _styled.div.withConfig({
  displayName: "InfoPage__Row",
  componentId: "sc-12lduoe-3"
})(["display:flex;justify-content:space-between;padding:0 20px;margin-top:", ";"], function (p) {
  return p.withMargin ? "40px" : "10px";
});

var RowLabel = _styled.div.withConfig({
  displayName: "InfoPage__RowLabel",
  componentId: "sc-12lduoe-4"
})([""]);

var RowValue = _styled.div.withConfig({
  displayName: "InfoPage__RowValue",
  componentId: "sc-12lduoe-5"
})(["color:#aaa;"]);

export function InfoPage() {
  var pathCreator = usePathCreator();

  var _useRegistersSubscrip = useRegistersSubscription(["motohoursCounter"]),
      motohoursCounter = _useRegistersSubscrip.registersData.motohoursCounter;

  var hardwareInfo = useHardwareInfo();
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/")
  }), /*#__PURE__*/React.createElement(Title, null, "\u0422\u0435\u043F\u043B\u043E\u0432\u043E\u0439 \u043D\u0430\u0441\u043E\u0441"), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C"), /*#__PURE__*/React.createElement(RowValue, null, hardwareInfo.vendorName)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, "\u041C\u043E\u0434\u0435\u043B\u044C"), /*#__PURE__*/React.createElement(RowValue, null, hardwareInfo.modelName)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, "\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440"), /*#__PURE__*/React.createElement(RowValue, null, hardwareInfo.serialNumber)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, "\u0413\u043E\u0434 \u0432\u044B\u043F\u0443\u0441\u043A\u0430"), /*#__PURE__*/React.createElement(RowValue, null, hardwareInfo.productionYear)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, "\u041C\u043E\u0442\u043E\u0447\u0430\u0441\u044B"), /*#__PURE__*/React.createElement(RowValue, null, motohoursCounter)), /*#__PURE__*/React.createElement(Row, {
    withMargin: true
  }, /*#__PURE__*/React.createElement(RowLabel, null, "\u0412\u0435\u0440\u0441\u0438\u044F \u041F\u041E"), /*#__PURE__*/React.createElement(RowValue, null, "1.002")), /*#__PURE__*/React.createElement(Row, {
    withMargin: true
  }, /*#__PURE__*/React.createElement(RowLabel, null, "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"), /*#__PURE__*/React.createElement(RowValue, null, hardwareInfo.contractNumber))));
}